module.exports = __webpack_public_path__ + "img/phone-image-2.eb82b5f6.svg";